module.exports = __webpack_public_path__ + "static/img/404.ac39b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/official/404.png
// module id = /qvd
// module chunks = 0